module.exports = __webpack_public_path__ + "static/media/new_argologo_light.9cbe3f92.svg";